import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators, FormGroupDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { toggleEditMode } from '../../../../shared/utils';
import { IAntrag } from '../../../models/antrag';
import { PopupService } from '../../../service/popup.service';
import { VorversicherungComponent } from '../../vorversicherung/vorversicherung.component';

@Component({
  selector: 'app-antrag-weitere-fragen',
  templateUrl: './antrag-weitere-fragen.component.html',
  styleUrls: ['./antrag-weitere-fragen.component.scss']
})
export class AntragWeitereFragenComponent implements OnInit {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  expertMode: boolean;

  @Input()
  versicherungsArt?: string;

  @Input()
  showVorversicherungGroup = false;

  @Output()
  kuendigungRisikenEvent = new EventEmitter<boolean>();

  @ViewChild('_vorversicherung') vorversicherungComponent: VorversicherungComponent;
  @ViewChild('_gekuendigteVorversicherung') gekuendigteVorversicherungComponent: VorversicherungComponent;

  constructor(public translateService: TranslateService, public popupService: PopupService, private ref: ChangeDetectorRef) { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      vorversicherung: new UntypedFormControl('', Validators.required),
      vorversicherungGroup: VorversicherungComponent.createFormGroup(fb),
      kuendigungRisiken: new UntypedFormControl('', Validators.required),
      gekuendigteVorversicherungGroup: VorversicherungComponent.createFormGroup(fb),
      datumKuendigung: new UntypedFormControl(''),
      grundKuendigung: new UntypedFormControl('')
    });
  }

  ngOnInit(): void {
    this.onValueChanged();
    this.toggleEditMode();
  }

  get vorversicherung() { return this.formGroup.get('vorversicherung'); }
  get vorversicherungGroup() { return this.formGroup.get('vorversicherungGroup'); }
  get kuendigungRisiken() { return this.formGroup.get('kuendigungRisiken'); }
  get gekuendigteVorversicherungGroup() { return this.formGroup.get('gekuendigteVorversicherungGroup'); }
  get datumKuendigung() { return this.formGroup.get('datumKuendigung'); }
  get grundKuendigung() { return this.formGroup.get('grundKuendigung'); }

  get showVorversicherungFelder() {
    return this.vorversicherung.value === 'ja' ? true : false;
  }

  get showKuendigungRisikenGroup() {
    return this.expertMode && this.kuendigungRisiken.value === 'ja';
  }

  get showGekuendigteVorversicherungFelder() {
    return this.showKuendigungRisikenGroup ? true : false;
  }

  toggleEditMode(): void {
    toggleEditMode(this.vorversicherung, this.showVorversicherungGroup);
    toggleEditMode(this.datumKuendigung, this.showKuendigungRisikenGroup);
    toggleEditMode(this.grundKuendigung, this.showKuendigungRisikenGroup);
  }

  onValueChanged(): void {
    this.kuendigungRisiken.valueChanges.subscribe(() => {
      this.kuendigungRisikenEvent.emit(this.kuendigungRisiken.value === 'ja' ? true : false);
      this.toggleEditMode();
      this.ref.detectChanges();
    });
    this.vorversicherung.valueChanges.subscribe(() => {
      this.toggleEditMode();
    });
  }

  setAntrag(antrag: IAntrag) {
    if (antrag.Vorversicherung) {
      this.vorversicherung.setValue('ja');
      this.vorversicherungComponent.setVorversicherung(antrag.Vorversicherung);
    } else {
      this.vorversicherung.setValue('nein');
    }
    this.kuendigungRisiken.setValue(antrag.KuendigungRisiken != null ? antrag.KuendigungRisiken === true ? 'ja' : 'nein' : null);
    this.ref.detectChanges();
    if (antrag.KuendigungRisiken && this.expertMode) {
      this.gekuendigteVorversicherungComponent.setVorversicherung(antrag.GekuendigteVorversicherung);
    }
    this.datumKuendigung.setValue(antrag.DatumKuendigung != null ? moment(antrag.DatumKuendigung) : null);
    this.grundKuendigung.setValue(antrag.GrundKuendigung);
  }

  getAntrag(): IAntrag {
    return {
      Vorversicherung: this.vorversicherungComponent ? this.vorversicherungComponent.getVorversicherung() : null,
      KuendigungRisiken: this.kuendigungRisiken.value ? this.kuendigungRisiken.value === 'ja' ? true : false : null,
      GekuendigteVorversicherung: this.gekuendigteVorversicherungComponent ?
        this.gekuendigteVorversicherungComponent.getVorversicherung() : null,
      DatumKuendigung: this.datumKuendigung.value,
      GrundKuendigung: this.grundKuendigung.value,
    } as IAntrag;
  }
}
